import { stripeIsIDealEnabled } from './StripeStore';

export const updateStripeIsIDealEnabled = (value) => stripeIsIDealEnabled.update((oldValue) => value);
